import { PageWrapper, Text } from "components";
export const AppCenterPage = () => {
  return (
    <PageWrapper>
      <Text size={"xxl"}>AppCenter page</Text>
    </PageWrapper>
  );
};
